export default {
	base: require("./base.vue").default,
	main: require("./main.vue").default,
	error: require("./error.vue").default
};
